import React from 'react';
import type { FactorRosterMember } from '../../../../types/statusFactors';

/** CONTRIB: read-only share of the blend — a decorative bar with the percentage centred over it. */
const ContribCell: React.FC<{ member: FactorRosterMember }> = ({ member }) => {
  if (member.hidden) return null;
  const percent = Math.round(member.share * 100);
  return (
    <span className="rollup-roster__contrib" data-testid="roster-cell-contrib">
      <span className="rollup-roster__contrib-text">{percent}%</span>
      <span className="rollup-roster__contrib-bar" aria-hidden="true">
        <span className="rollup-roster__contrib-fill" style={{ width: `${percent}%` }} />
      </span>
    </span>
  );
};

export default ContribCell;
